// src/utils/axiosInstance.js
import axios from 'axios';
export const BACKEND_ROOT_URL = "https://www.afrinjewelry.com/api"
// export const BACKEND_ROOT_URL = "http://localhost:8000"
const axiosInstance = axios.create({
  // baseURL: 'http://localhost/sahimapi/api',
    baseURL:'/api'
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token'); // Get token from localStorage
  console.log("Token", token)
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axiosInstance;
